import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from "react";

// Общий кирпичик дизайна: кнопка/ссылка вида `[текст]`, без фона и рамки — как
// sub-page/src/views/partials/link-button.hbs, только React-компонент вместо hbs-партиала.
const base =
  "bg-transparent border-0 p-0 cursor-pointer transition-opacity duration-150 hover:opacity-80 disabled:opacity-50 disabled:cursor-default";

interface CommonProps {
  children: ReactNode;
  active?: boolean;
  className?: string;
}

type LinkButtonProps =
  | (CommonProps & { href: string } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "className" | "children">)
  | (CommonProps & { href?: undefined } & Omit<ButtonHTMLAttributes<HTMLButtonElement>, "className" | "children">);

export function LinkButton({ children, active, className, ...rest }: LinkButtonProps) {
  const colorClass = active === false ? "text-fg" : "text-accent-green";
  const classes = [base, colorClass, className].filter(Boolean).join(" ");

  if (rest.href) {
    return (
      <a className={classes} {...(rest as AnchorHTMLAttributes<HTMLAnchorElement>)}>
        [{children}]
      </a>
    );
  }

  return (
    <button type="button" className={classes} {...(rest as ButtonHTMLAttributes<HTMLButtonElement>)}>
      [{children}]
    </button>
  );
}
